import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ApiRoutesService} from './api-routes.service';
import {Member} from '../models/user/member.model';
import { UpdateMember } from '../models/user/update-member.model';

export interface ChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
  newPasswordConfirmation: string;
}

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  readonly #httpClient = inject(HttpClient);
  readonly #routes = inject(ApiRoutesService);

  public me(): Observable<Member> {
    return this.#httpClient.get<Member>(this.#routes.me());
  }

  public updateMe(updateMember: UpdateMember): Observable<Member> {
    return this.#httpClient.patch<Member>(this.#routes.me(), updateMember);
  }

  /** Changement de mot de passe depuis son profil (ancien mot de passe exigé). */
  public changePassword(payload: ChangePasswordPayload): Observable<void> {
    return this.#httpClient.put<void>(this.#routes.mePassword(), payload);
  }

  public findByCommunity(communityId: string): Observable<Member[]> {
    return this.#httpClient.get<Member[]>(`${this.#routes.community()}/${communityId}/members`);
  }
}
